/* global __SKIN__*/
import Config from "./conf";
import Helpers from '@common/helpers/helperFunctions';

Config.env = Config.env || {};

// Use Vite's glob import to load all skin configs at build time 
const skinConfigs = import.meta.glob('../../skins/*/config.mjs', { eager: true });
const skinRules = import.meta.glob('../../skins/*/rules.jsx', { eager: true });

// Find and merge the config for the current skin
const skinConfigPath = `../../skins/${__SKIN__}/config.mjs`;
const skinConfigModule = skinConfigs[skinConfigPath];
if (skinConfigModule) {
  const skinConfig = skinConfigModule.default || skinConfigModule;
  Helpers.mergeRecursive(Config, skinConfig);
}

// Try to load rules if they exist
const skinRulesPath = `../../skins/${__SKIN__}/rules.jsx`;
const skinRulesModule = skinRules[skinRulesPath];
if (skinRulesModule) {
  const Rules = skinRulesModule.default || skinRulesModule;
  Helpers.mergeRecursive(Config, Rules);
} else {
  console.log('rules.jsx not exist in skin');
}

export default Config;
